/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { Box, Text, theme } from "@nordcloud/gnui";
import { LoaderWrap } from "~/components/Loader/LoaderWrap";
import { TextButton } from "~/components/Styled";
import { inflect } from "~/tools";

export type SelectionBannerProps = {
  itemName: string;
  totalItems: number;
  selectedItemCount: number;
  areAllItemsSelected: boolean;
  showSelectAllItems: boolean;
  clearItemsSelection?: () => void;
  selectAllItems?: () => void;
  areAllItemsLoading?: boolean;
};

export function SelectionBanner({
  itemName,
  totalItems,
  selectedItemCount,
  areAllItemsSelected,
  showSelectAllItems = true,
  clearItemsSelection,
  selectAllItems,
  areAllItemsLoading = false,
}: SelectionBannerProps) {
  if (!selectedItemCount) {
    return null;
  }

  const selectAllItemsText = showSelectAllItems
    ? `Select all ${totalItems} ${inflect(itemName)(
        totalItems
      )} across all pages.`
    : "";

  return (
    <Box
      boxStyle="lightGrey"
      style={{
        border: `1px solid ${theme.color.border.border01}`,
        marginBottom: `${theme.spacing.spacing04}`,
      }}
    >
      <LoaderWrap loading={areAllItemsLoading} inContent>
        <Text
          style={{ whiteSpace: "nowrap", lineHeight: "1.5", marginBottom: 0 }}
        >
          {areAllItemsSelected
            ? `All ${totalItems} ${inflect(itemName)(totalItems)} ${
                totalItems > 1 ? "are" : "is"
              } selected. `
            : `${selectedItemCount} ${inflect(itemName)(selectedItemCount)} ${
                selectedItemCount > 1 ? "are" : "is"
              } selected. `}
          <When condition={showSelectAllItems}>
            <TextButton
              underline
              onClick={
                areAllItemsSelected ? clearItemsSelection : selectAllItems
              }
            >
              {areAllItemsSelected ? "Clear selection" : selectAllItemsText}
            </TextButton>
          </When>
        </Text>
      </LoaderWrap>
    </Box>
  );
}
